
import React, { useState, useEffect } from "react";
import axios from "axios";
import LoadingSpinner from "./components/Helpers/LoadingSpinner";
import { XAxis, YAxis, CartesianGrid, Tooltip, Legend, AreaChart, Area } from 'recharts';
import { BarChart, Bar } from 'recharts';
import { Button, Form, InputGroup } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Table from "./components/Table";
import { Table as BSTable } from "react-bootstrap";
import Moment from "react-moment";
import moment from "moment-timezone";
import Panel from "./components/Panel";
import { Spinner } from "react-bootstrap";
import { useHistory } from 'react-router-dom';

function Customers( ) {
  const [customersData, setCustomersData] = useState();

  const getCustomers = () => {
    axios
    .get(`${process.env.REACT_APP_API ? process.env.REACT_APP_API : window.location.origin}/gui/v1/customers.json`)
    .catch((error) => console.error(error))
    .then(({ data }) => {
      setCustomersData(data.customers)
    })
  }

useEffect(() => {
  getCustomers();
}, []);

const gridOptions = {
  getRowId(data) {
    console.log(data)
    return data.data.id;
  },
  paginationPageSize: 32,
  columnDefs: [
    {
      headerName: "Name",
      cellRenderer: function(params) {
        return (<a href={`/customer/${params.data.id}`}>{params.data.surname}, {params.data.first_name}</a>)
      }
    }, {
      headerName: "E-Mail",
      field: "email"
    }, {
      headerName: "Active",
      field: "active"
    }
  ]
}

return (
  <div className="App">
      <h1>Customers</h1>
      <a href="/customerNew">New Customer</a>
      <Table gridOptions={gridOptions} rowData={customersData}/>
  </div>


)

}

export default Customers